namespace HTMLUtils {
	export function addClass(elem:HTMLElement, cls:string):void {
		if (elem.className.length === 0) {
			elem.className = cls;
		} else {
			let list = elem.className.split(' ');
			if (list.indexOf(cls) < 0) {
				elem.className += ' ' + cls;
			}
		}
	}

	export function removeClass(elem:HTMLElement, cls:string):void {
		let list = elem.className.split(' ');
		let index = list.indexOf(cls);
		if (index >= 0) {
			list.splice(index, 1);
			elem.className = list.join(' ');
		}
	}

	export function createXML(rootName:string = '') {
	    var xmlDoc = CreateMSXMLDocumentObject();
	    if (xmlDoc) {
	        if (rootName) {
	            var rootNode = xmlDoc.createElement(rootName);
	            xmlDoc.appendChild(rootNode);
	        }
	    } else {
	        if (document.implementation && document.implementation.createDocument) {
	            xmlDoc = document.implementation.createDocument ('', rootName, null);
	        }
	    }
	    
	    return xmlDoc;
	}

	function CreateMSXMLDocumentObject () {
	    if (typeof (ActiveXObject) != "undefined") {
	        var progIDs = [
	                        "Msxml2.DOMDocument.6.0", 
	                        "Msxml2.DOMDocument.5.0", 
	                        "Msxml2.DOMDocument.4.0", 
	                        "Msxml2.DOMDocument.3.0", 
	                        "MSXML2.DOMDocument", 
	                        "MSXML.DOMDocument"
	                      ];
	        for (var i = 0; i < progIDs.length; i++) {
	            try { 
	                return new ActiveXObject(progIDs[i]); 
	            } catch(e) {};
	        }
	    }
	    return null;
	}

	export function setXMLTextContent(elem:any, text:string):void {
		if (elem.textContent) {
			elem.textContent = text;
		} else {
			elem.text = text;
		}
	}

	export function setTextContent(elem:HTMLElement, text:string):void {
		if (elem.textContent) {
			elem.textContent = text;
		} else {
			elem.innerText = text;
		}
	}

	export function getEventTarget(e:Event):EventTarget {
		return e.target || e.srcElement;
	}

	export function init() {
		onWindowResize = new Signal<()=>void>();
	}

	export var onWindowResize:Signal<()=>void>;
}